<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>Text copyright © 2013 by Katie Sullivan Morford.<br/>Photographs copyright © Chronicle Books LLC.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 978-1-4521-3903-6</p>
<p>The Library of Congress has previously cataloged this under:</p>
<p>ISBN 978-1-4521-0829-2</p>
<p>Designed by Eight Hour Day<br/>Photographs by Jennifer Martiné<br/>Food styling Karen Shinto<br/>Prop styling by Leigh Noe</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?33d95b19